// Minimal Klaviyo cart tracker dla "Cart Updated"
// Wymaga skryptu Klaviyo Web tracking (window._learnq)
// Debounce i pomija strony checkout

(function () {
  console.log('[KLAV] Script loaded');
  
  const KLAVIYO_EVENT_NAME = 'Cart Updated';
  const isCheckout = () => location.pathname.startsWith('/checkout');

  function klaviyoIdentify(profile) {
    try {
      // Użyj starego API (kolejka)
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', profile]);
      console.log('[KLAV] identify via old API queue');
    } catch (e) { 
      console.error('[KLAV] Error in klaviyoIdentify:', e); 
    }
  }

  function klaviyoTrack(eventName, props) {
    try {
      // Użyj starego API (kolejka)
      window._learnq = window._learnq || [];
      window._learnq.push(['track', eventName, props]);
      console.log('[KLAV] track via old API queue');
    } catch (e) { 
      console.error('[KLAV] Error in klaviyoTrack:', e); 
    }
  }

  function identifyIfPossible() {
    try {
      const c = window.__shopifyCustomer || {};
      if (c && c.email) {
        console.log('[KLAV] Identifying customer:', c.email);
        klaviyoIdentify({
          $email: c.email,
          $first_name: c.first_name || undefined,
          $last_name: c.last_name || undefined
        });
      } else {
        console.log('[KLAV] No customer email, skipping identify');
      }
    } catch (e) {
      console.error('[KLAV] Error in identifyIfPossible:', e);
    }
  }

  async function fetchCart() {
    try {
      console.log('[KLAV] Fetching cart...');
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Failed to fetch cart');
      const cart = await res.json();
      console.log('[KLAV] Cart fetched:', cart);
      return cart;
    } catch (e) {
      console.error('[KLAV] Error fetching cart:', e);
      throw e;
    }
  }

  function mapCart(cart) {
    const props = {
      cart_token: cart.token,
      currency: cart.currency,
      total_price: cart.total_price,
      item_count: cart.item_count,
      url: location.href,
      items: (cart.items || []).map(i => ({
        product_id: i.product_id,
        variant_id: i.variant_id,
        sku: i.sku,
        title: i.title,
        quantity: i.quantity,
        price: i.price,
        line_price: i.line_price,
        url: i.url,
        image: i.image,
        vendor: i.vendor,
        product_type: i.product_type,
        properties: i.properties || null
      })),
      attributes: cart.attributes || null,
      note: cart.note || null
    };
    console.log('[KLAV] Mapped cart props:', props);
    return props;
  }

  let lastToken = null;
  let debounceId;

  async function sendCartEvent() {
    try {
      console.log('[KLAV] sendCartEvent called');
      
      if (isCheckout()) {
        console.log('[KLAV] Skipping - on checkout page');
        return;
      }
      
      const cart = await fetchCart();
      if (!cart?.items?.length) {
        console.log('[KLAV] Skipping - empty cart');
        return;
      }

      // Unikaj duplikatów dla tego samego tokenu koszyka
      if (cart.token && cart.token === lastToken) {
        console.log('[KLAV] Skipping - same token as last send');
        return;
      }

      clearTimeout(debounceId);
      debounceId = setTimeout(() => {
        try {
          const props = mapCart(cart);
          
          identifyIfPossible();
          console.log('[KLAV] Sending Cart Updated event to Klaviyo:', props);
          klaviyoTrack(KLAVIYO_EVENT_NAME, props);
          lastToken = cart.token || null;
          console.log('[KLAV] Event sent successfully');
        } catch (e) {
          console.error('[KLAV] Error in sendCartEvent timeout:', e);
        }
      }, 800);
    } catch (e) {
      console.error('[KLAV] Error in sendCartEvent:', e);
    }
  }

  // Pierwsze uruchomienie po załadowaniu strony
  console.log('[KLAV] Adding DOMContentLoaded listener');
  document.addEventListener('DOMContentLoaded', sendCartEvent);

  // Podpięcie do eventów koszyka z main.js:
  // - on:cart:add (po dodaniu do koszyka)
  // - on:cart:change (po aktualizacji/usunięciu)
  console.log('[KLAV] Adding on:cart:add listener');
  document.addEventListener('on:cart:add', sendCartEvent);
  
  console.log('[KLAV] Adding on:cart:change listener');
  document.addEventListener('on:cart:change', sendCartEvent);

  console.log('[KLAV] All listeners added');
})();